import { render, staticRenderFns } from "./HlaViewVirtualCrossmatchHistory.vue?vue&type=template&id=55546ee8&"
import script from "./HlaViewVirtualCrossmatchHistory.vue?vue&type=script&lang=ts&"
export * from "./HlaViewVirtualCrossmatchHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/hla/_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fhla%2FHlaViewVirtualCrossmatchHistory.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/hla/_locales/HlaViewVirtualCrossmatchHistory.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fhla%2FHlaViewVirtualCrossmatchHistory.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports